import Class from './c-content-chart-flat-pie';
import './c-content-chart-flat-pie@.vue';

export default Class;